import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  // Determine phase based on step
  // 1-2: Promise (Hook + Quiz)
  // 3-7: Effort (Perception + Selection + DeepDive + Behavior + DriversBarriers)
  // 8-14: Reward (Reality + Perception Reveal + Comparison + System + Brand + Activation + Summary)
  let phase = 'Promise';
  if (currentStep >= 3 && currentStep <= 7) phase = 'Effort';
  if (currentStep >= 8) phase = 'Reward';
  const progress = currentStep / totalSteps * 100;
  return <div className="fixed top-0 left-0 w-full z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100" data-id="element-169">
      <div className="max-w-3xl mx-auto px-6 py-3 flex justify-between items-center text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-170">
        <div className="flex space-x-8" data-id="element-171">
          <span className={phase === 'Promise' ? 'text-brand' : ''} data-id="element-172">
            Promise
          </span>
          <span className={phase === 'Effort' ? 'text-brand' : ''} data-id="element-173">Effort</span>
          <span className={phase === 'Reward' ? 'text-brand' : ''} data-id="element-174">Reward</span>
        </div>
        <div data-id="element-175">
          {currentStep} / {totalSteps}
        </div>
      </div>
      <div className="h-1 w-full bg-gray-100" data-id="element-176">
        <motion.div className="h-full bg-brand" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-177" />
      </div>
    </div>;
}